import { Injectable } from '@angular/core';
import { ID, Order, QueryEntity } from '@datorama/akita';
import { filter, map } from 'rxjs';
import { ContactsFilterState } from './contact.model';
import { ContactState, ContactStore } from './contact.store';

@Injectable({ providedIn: 'root' })
export class ContactQuery extends QueryEntity<ContactState> {
  filter$ = this.select(state => state.filter);
  blackList$ = this.select(state => state['blacklist']);
  whiteList$ = this.select(state => state['whitelist']);

  contacts$ = this.selectAll({
    sortBy: 'displayName',
    sortByOrder: Order.ASC
  });

  constructor(protected override store: ContactStore) {
    super(store);
    this.createUIQuery();
  }

  getContact(customerUuid: string | ID) {
    return this.getEntity(customerUuid);
  }

  selectContact(customerUuid: string | ID) {
    return this.selectEntity(customerUuid);
  }

  getFilterState(): ContactsFilterState {
    return this.getValue().filter;
  }

  getContactByChatCustomerId(chatCustomerId: string) {
    const find = this.getAll({
      filterBy: entity => !!entity.chatCustomerId && entity.chatCustomerId === chatCustomerId,
      limitTo: 1
    });
    return find?.length > 0 ? find[0] : null;
  }

  selectContactByChatUuid(chatUuid: string) {
    return this.selectAll({ filterBy: user => user.chatCustomerId === chatUuid, limitTo: 1 }).pipe(
      filter(x => x != null),
      map(x => x[0])
    );
  }

  searchContact(query: string) {
    return this.getAll({
      filterBy: contact =>
        contact.fullName.toLowerCase().includes(query) || contact.numbers?.toString().includes(query),
      sortBy: 'displayName',
      sortByOrder: Order.ASC
    });
  }

  selectContactByName(searchValue: string) {
    searchValue = searchValue.toLowerCase();
    return this.selectAll({
      filterBy: entity =>
        entity.displayName?.toLowerCase().indexOf(searchValue) >= 0 ||
        entity?.numbers?.some(x => x.number.includes(searchValue))
    });
  }
}
